export const SOCIAL_AUTH_SOURCE_SIGNUP = 'signup';
const IRL_EVENT_AUTH_SOURCE_SOCIAL = 'social';
const IRL_EVENT_SOCIAL_METHODS = ['google', 'apple'];

export const normalizeIsNewUser = (isNewUser: string[] | string | undefined): 'false' | 'true' | undefined => {
  const value = Array.isArray(isNewUser) ? isNewUser[isNewUser.length - 1] : isNewUser;

  if (value === undefined) {
    return undefined;
  }

  return value === 'true' ? 'true' : 'false';
};

// Call only with a URL that has already passed sanitizeUrl + isSameDomain validation,
// so `new URL` here is guaranteed not to throw.
export const appendIsNewUserToRedirectUrl = (
  validatedRedirectUrl: string,
  isNewUser: string[] | string | undefined
): string => {
  const url = new URL(validatedRedirectUrl);

  // The IRL-event flow marks its social redirect URLs with authSource=social plus an explicit
  // authMethod param (set only when the signup-analytics rollout flag is on), so forwarding
  // isNewUser stays flag-gated and cannot affect plain IRL social logins.
  const isSignupRedirect =
    url.searchParams.get('socialAuthSource') === SOCIAL_AUTH_SOURCE_SIGNUP ||
    (url.searchParams.get('authSource') === IRL_EVENT_AUTH_SOURCE_SOCIAL &&
      IRL_EVENT_SOCIAL_METHODS.includes(url.searchParams.get('authMethod') ?? ''));

  if (!isSignupRedirect) {
    return validatedRedirectUrl;
  }

  const normalizedIsNewUser = normalizeIsNewUser(isNewUser);

  if (normalizedIsNewUser === undefined) {
    url.searchParams.delete('isNewUser');
    return url.toString();
  }

  url.searchParams.set('isNewUser', normalizedIsNewUser);

  return url.toString();
};
